import React from "react";
import { useState } from "react";
import { Typography, Divider, useMediaQuery } from "@mui/material";
import "@fontsource/rubik/500.css";
import "@fontsource/rubik/400.css";
import ExpandInfo from "./ExpandInfo";

const Step3Casnic = () => {
  const isLaptop = useMediaQuery("(max-width: 1400px)");
  const isMobile = useMediaQuery("(max-width: 1024px)");
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? 0 : "140px",
          marginRight: isMobile ? -20 : "140px",
          marginTop: isMobile ? -50 : "50px",
        }}
      >
        {!isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: isLaptop ? "32rem" : "28rem",
              width: "4px",
              backgroundColor: "#29348f",
            }}
          />
        ) : (
          ""
        )}
        <div style={{ marginLeft: 34 }}>
          <div
            variant="contained"
            style={{
              backgroundColor: "#29348f",
              borderRadius: isMobile
                ? "20px 0px 0px 20px"
                : "0px 20px 20px 0px",
              textTransform: "none",
              height: 40,
              width: 80,
              paddingLeft: 16,
              paddingTop: 8,
              marginLeft: isMobile ? "auto" : "",
            }}
          >
            <Typography variant="body1" color="white">
              DEER
            </Typography>
          </div>
          <Typography variant="h6" sx={{ mt: 4 }}>
            Stabilirea soluției de racordare{" "}
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Prin fișă de soluție (FS)
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            Conform Ord. 18/2022 soluția de racordare se stabilește doar prin FS{" "}
          </Typography>
          <Typography variant="h6" sx={{ mt: 4 }}>
            Emitere aviz tehnic de racordare{" "}
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Soluție stabilită prin fișa de soluție{" "}
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            (Noi analizăm documentele pe care ni le-ai trimis împreună cu
            cererea de racordare și îți trimitem factura aferentă emiterii
            avizului tehnic de racordare. Vei primi avizul, numai după achitarea
            facturii.Avizul tehnic de racordare conţine soluţia tehnică de
            racordare la reţeaua de energie electrică, valoarea estimată a
            lucrărilor precum şi toate informaţiile necesare realizării
            instalaţiei. )
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            Canale de comunicare electronică (portal).
          </Typography>

          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            30 zile calendaristice de la primirea cererii de racordare la rețea,
            însoțită de documentația completă{" "}
          </Typography>
        </div>
        {isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: "48rem",
              width: "4px",
              backgroundColor: "#29348f",
              ml: 2,
            }}
          />
        ) : (
          ""
        )}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? -30 : "140px",
          marginTop: "50px",
          marginRight: isMobile ? 0 : "140px",
          marginBottom: "60px",
        }}
      >
        <Divider
          orientation="vertical"
          sx={{
            height: "4rem",
            width: "4px",
            backgroundColor: "#29348f",
            mr: isMobile ? 3 : "",
          }}
        />
        <ExpandInfo />
      </div>
    </div>
  );
};

export default Step3Casnic;
